import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiservicesService } from '../../../../apiservices.service';
import { UserTopComponent } from '../../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../../services/encryptdecrypt.service';
import { APP_CONFIG, AppConfig } from '../../../../app-config';
import { WindowFormService } from '../../../../services/window-form.service';
import { NoticeDialogService } from 'src/app/components/shared/notice-dialog.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-butiran-penerimaan-pelantikan-permohonan-online',
  templateUrl: './butiran-penerimaan-pelantikan-permohonan-online.component.html',
  styleUrls: ['./butiran-penerimaan-pelantikan-permohonan-online.component.css']
})
export class ButiranPenerimaanPelantikanPermohonanOnlineComponent implements OnInit {

  @ViewChild('cancelCloseButton') cancelCloseButton: any;
  @ViewChild('rejectCloseButton') rejectCloseButton: any;

  //UI Input Process Lantikan
  ProcessRemarks: any = "";

  //Open Window
  openedWindowStatus: any = null;

  //UI Input Variables
  FormTypeInput: any = "";
  YearAssessmentInput: any = "";
  CKMYearAssessmentInput: any = "";
  CP22YearAssessmentInput: any = "";

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //UI status variables
  LoaderStatus: boolean = false;
  PageStatus: any = "";
  LantikanID: any = "";
  EBorangStatus: boolean = false;
  EBorangAccessView: boolean = false;
  LejarAccessView: boolean = false;
  ProfileAccessView: boolean = false;
  IsAdminStatus: boolean = false;
  YearAssessmentRegisterStatus: boolean = false;
  FormButtonStatus: boolean = false;
  LedgerButtonStatus: boolean = false;
  ProfileButtonStatus: boolean = false;
  RevokeButtonStatus: boolean = false;
  ProcessButtonStatus: boolean = false;

  //UI View Variables
  TaxpayerNameView: any = "";
  TaxpayerIDNoView: any = "";
  TaxpayerItGrpView: any = "";
  TaxpayerTINView: any = "";
  TaxpayerPhoneNoCountryCodeNo: any = "";
  TaxpayerPhoneNoView: any = "";
  TaxpayerEmailView: any = "";
  TaxAgentNameView: any = "";
  TaxAgentIDView: any = "";
  FirmNameView: any = "";
  AppointedDateView: any = "";
  ActionDateView: any = "";
  RevokeDateView: any = "";
  RevokeByNameView: any = "";
  StatusView: any = "";
  StatusNamingView: any = "";
  RemarksView: any = "";
  AgentRemarksView: any = "";
  AdminName: any = "";

  //SessionData
  SessionRoles: any = [];
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  SessionStaffIDNo: any = "";
  SessionParams: any = "";
  SessionIPAddress: any;

  //UI List Variables
  FormTypeList: any[] = [];
  YearAssessmentList: any[] = [];

  //Reset Form Variable
  TaxRefNumResetForm: any = "";
  FormTypeResetForm: any = "";
  YearAssessmentResetForm: any = "";

  //UI Agih Variables
  DistributeTaxpayerNameView: any = "";
  DistributeFormTypeView: any = "";
  DistributeStaffNameView: any = "";
  DistributeTaxpayerRefNumView: any = "";
  DistributeRegisterDateView: any = "";
  DistributeStaffList: any;
  DistributeStaffInput: any = "";
  DistributeOldStaffID: any = "";
  DistributeSupervisorInput: any = "";
  DistributeTaxAgentIDView: any = "";
  DistributeTaxReturnFormID: any = "";

  //Datatable Variables
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataSource = new MatTableDataSource();
  dataSourceOtherFirm = new MatTableDataSource();
  displayedColumns = ['jenisborang', 'staffname', 'agentname', 'tarikhdaftar', 'tarikhhantar', 'action'];
  displayedColumnsOtherFirm = ['jenisborang', 'tarikhdaftar'];

  // Config property for HTML access
  MyTaxAddress: string = "";
  beLoginUrl: string = "";
  yearBeStartOauth: number = 2025;

  constructor(
    private apiServices: ApiservicesService,
    private router: Router,
    private top: UserTopComponent,
    private encryptDecryptService: EncryptdecryptService,
    @Inject(APP_CONFIG) private config: AppConfig,
    private windowForm: WindowFormService,
    private noticeDialog: NoticeDialogService 
  ) {
    this.MyTaxAddress = config.MyTaxAddress;
    this.beLoginUrl = config.beLoginUrl;
    this.yearBeStartOauth = config.YearBeStartOauth ?? 2025; // <-- load from config
  }

  async ngOnInit(): Promise<void> {
    this.top.updateTotal();
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.SessionStaffIDNo = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '');
    this.SessionParams = sessionStorage.getItem('tempParams');
    this.SessionParams = JSON.parse(this.SessionParams);
    this.LantikanID = await this.apiServices.GetEncryptDecrypt("202", this.SessionParams.LantikanID);
    this.PageStatus = await this.apiServices.GetEncryptDecrypt("202", this.SessionParams.status);
    //this.LantikanID = this.activedRoute.snapshot.params['ID'];
    //this.PageStatus = this.activedRoute.snapshot.params['status'];
    this.GetData(this.SessionFirmID, this.SessionStaffID, this.LantikanID);
  }
  async GetData(FirmID:any,StaffID:any, LantikanID:any) {
    this.LoaderStatus = true;
    let Params = {
      "FirmID": FirmID,
      "LantikanID": LantikanID,
      "StaffID": StaffID
    }
    const result = await this.apiServices.GetLantikanByID(Params);

    this.TaxpayerNameView = result.taxPayerName;
    if (result.itGrpCd === "IG") {
      if (result.taxPayerICNo !== "" && result.taxPayerICNo !== null)
        this.TaxpayerIDNoView = result.taxPayerICNo;
      else if (result.taxpayerPassportNo !== "" && result.taxpayerPassportNo !== null)
        this.TaxpayerIDNoView = result.taxpayerPassportNo;
      else if (result.taxpayerPoliceArmyNo !== "" && result.taxpayerPoliceArmyNo !== null)
        this.TaxpayerIDNoView = result.taxpayerPoliceArmyNo;

      if (result.mobilePhoneNo === "" || result.mobilePhoneNo === null) {
        this.TaxpayerPhoneNoView = "N/A";
        this.TaxpayerPhoneNoCountryCodeNo = "";
      } else {
        this.TaxpayerPhoneNoView = result.mobilePhoneNo;
        if (result.mobilePhoneNoCountryCode === "" || result.mobilePhoneNoCountryCode === null) {
          this.TaxpayerPhoneNoCountryCodeNo = "";
        } else {
          this.TaxpayerPhoneNoCountryCodeNo = "(+" + result.mobilePhoneNoCountryCode + ")";
        }
      }
    } else {
      this.TaxpayerIDNoView = (result.busRegistNo == null || result.busRegistNo.replace(/\s/g, "") == "") ? "N/A" : result.busRegistNo;
      if (result.phoneNo === null || result.phoneNo.replace(/\s/g, "") === "") {
        this.TaxpayerPhoneNoView = "N/A";
        this.TaxpayerPhoneNoCountryCodeNo = "";
      } else {
        this.TaxpayerPhoneNoView = result.phoneNo;
        if (result.phoneNoCountryCode === null || result.phoneNoCountryCode.replace(/\s/g, "") === "") {
          this.TaxpayerPhoneNoCountryCodeNo = "";
        } else {
          this.TaxpayerPhoneNoCountryCodeNo = "(+" + result.phoneNoCountryCode + ")";
        }
      }
    }
    this.TaxpayerItGrpView = result.itGrpCd;
    this.TaxpayerTINView = result.itrefNo;
    this.TaxpayerEmailView = result.email === "" || result.email === null ? "N/A" : result.email;
    this.TaxAgentNameView = result.taxAgentName;
    this.TaxAgentIDView = result.taxAgentId;
    this.EBorangAccessView = result.accessBorang;
    this.LejarAccessView = result.accessLejar;
    this.ProfileAccessView = result.accessProfile;
    this.FormButtonStatus = result.formButton;
    this.LedgerButtonStatus = result.ledgerButton;
    this.ProfileButtonStatus = result.profileButton;
    this.RevokeButtonStatus = result.revokeButton;
    this.ProcessButtonStatus = result.processButton;
    this.FirmNameView = result.firmName;
    this.AppointedDateView = formatDate(result.dateRequest, 'dd-MMM-yyyy h:mm:ss a', "en-US");
    this.RevokeDateView = result.dateCancel === null || result.dateCancel === "" ? "N/A" : formatDate(result.dateCancel, 'dd-MMM-yyyy h:mm:ss a', "en-US");
    this.RevokeByNameView = result.revokeName + " (" + result.revokeBy + ")"; 
    this.ActionDateView = result.dateAssign === null || result.dateAssign === "" ? "N/A" : formatDate(result.dateAssign, 'dd-MMM-yyyy h:mm:ss a', "en-US");
    this.StatusNamingView = result.status.charAt(0).toUpperCase() + result.status.slice(1);
    this.StatusView = result.status;
    this.TaxAgentNameView = result.taxAgentName;
    this.TaxAgentIDView = result.taxAgentId;
    this.RemarksView = result.remarks === null || result.remarks === "" ? "N/A" : result.remarks; 
    this.AgentRemarksView = result.agentRemarks === null || result.agentRemarks === "" ? "N/A" : result.agentRemarks;
    this.AdminName = result.adminName === null || result.adminName === "" ? "N/A" : result.adminName;
    this.LoaderStatus = false;
  }
  EBorangClick(TaxRefNum: any) {
    this.EBorangStatus = !this.EBorangStatus;
    if (this.EBorangStatus) {
      this.ViewEBorang(TaxRefNum);
    }
  }
  async ViewEBorang(TaxRefNum: any) {
    this.ResetValue();
    this.LoaderStatus = true;
    let Params = {};
    if (sessionStorage.getItem('TaxAgentID') === null) {
        Params = {
          "ITRefNo": TaxRefNum,
          "FirmID": this.SessionFirmID,
          "StaffID": this.SessionStaffID
        }; 
    } else {
        Params = {
          "ITRefNo": TaxRefNum,
          "FirmID": this.SessionFirmID,
          "StaffID": this.SessionStaffID,
          "AgentID": this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || '')
        };
    }
    const result = await this.apiServices.GetListeBorang(Params);
    if (result.hasError) {
      this.LoaderStatus = false;
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
    } else {
      result.eBorangFirma.forEach((currentValue: any, index: any) => {
        result.eBorangFirma[index].dateRegister = formatDate(result.eBorangFirma[index].dateRegister, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        result.eBorangFirma[index].dateSubmit = result.eBorangFirma[index].dateSubmit === null || result.eBorangFirma[index].dateSubmit === "" || result.eBorangFirma[index].dateSubmit === undefined ? "N/A" : formatDate(result.eBorangFirma[index].dateSubmit, 'dd-MMM-yyyy h:mm:ss a', "en-US");
      });

      result.eBorangOthers.forEach((currentValue: any, index: any) => {
        result.eBorangOthers[index].dateRegister = formatDate(result.eBorangOthers[index].dateRegister, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        result.eBorangOthers[index].dateSubmit = result.eBorangOthers[index].dateSubmit === null || result.eBorangOthers[index].dateSubmit === "" || result.eBorangOthers[index].dateSubmit === undefined ? "N/A" : formatDate(result.eBorangOthers[index].dateSubmit, 'dd-MMM-yyyy h:mm:ss a', "en-US");
      });

      this.SessionRoles = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffRoles') || '');
      const Roles = JSON.parse(this.SessionRoles);
      Roles.forEach((currentValue: any, index: any) => {
        if (Roles[index] === "0201") {
          this.IsAdminStatus = true;
        }
      });
      this.dataSource = new MatTableDataSource(result.eBorangFirma);
      this.dataSourceOtherFirm = new MatTableDataSource(result.eBorangOthers);
      result.eBorang.forEach((currentValue: any, index: any) => {
        this.FormTypeList.push(result.eBorang[index]);
      });

    }
    this.LoaderStatus = false;
  }
  async GetStaff(TaxReturnFormID:any,StaffID: any, FirmID: any) {
    let Params = {};
    if (sessionStorage.getItem('TaxAgentID') === null) {
      Params = {
        "FirmID": FirmID,
        "TaxReturnFormID": TaxReturnFormID,
        "StaffID": StaffID
      }
    } else {
      Params = {
        "FirmID": FirmID,
        "TaxReturnFormID": TaxReturnFormID,
        "StaffID": StaffID,
        "TaxAgentID": this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || '')
      }
    }
    const result = await this.apiServices.GetDistributeList(Params);
    if (result.length > 0) {
      result.forEach((currentValue: any, index: any) => {
        switch (result[index].staffRole) {
          case "0202":
            result[index].staffName = result[index].staffName + " - (Penyelia)";
            break;
          case "0203":
            result[index].staffName = result[index].staffName + " - (Staf)";
            break;
          case "0204":
            result[index].staffName = result[index].staffName + " - (Ejen Cukai)";
            break;
          default:
            result[index].staffName = result[index].staffName;
            break;
        }
      });
    }
    
    this.DistributeStaffList = result;
  }
  async ProcessLantikan(Status: any, Remarks: any) {
    this.LoaderStatus = true;
    if (Status === "Ditolak" && Remarks === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila isi huraian";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else if (Status === "Dibatalkan" && Remarks === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila isi huraian";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else if ((Status === "Ditolak" || Status === "Diluluskan" || Status == "Dibatalkan") && Remarks.length > 150) {
      this.AlertType = "fail";
      this.AlertMessage = "Huraian hanya 150 aksara sahaja";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.cancelCloseButton.nativeElement.click();
      this.rejectCloseButton.nativeElement.click();
      let Params = {
        "FirmID": this.SessionFirmID,
        "LantikanID": this.LantikanID,
        "Status": Status,
        "Remarks": Remarks,
        "StaffID": this.SessionStaffID,
      }
      const result = await this.apiServices.ProcessLantikan(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.router.navigate(['/penerimaan-pelantikan-permohonan-online']);
          this.AlertStatus = false;
          //this.LoaderStatus = false;
        }, 2000);

        this.LoaderStatus = false;
      }
    }
  }
  Back() {
    this.router.navigate(['/penerimaan-pelantikan-permohonan-online']);
  }
  ChangeFormTypeRegister(FormType: any) {
    this.YearAssessmentList = [];
    this.FormTypeList.forEach((currentValue: any, index: any) => {
      if (FormType === this.FormTypeList[index].formName) {
        this.YearAssessmentList.push(this.FormTypeList[index].formYear);
      }
    });
    this.YearAssessmentRegisterStatus = true;
  }
  async RegisterForm(FormType: any, YearAssessment: any, AgentID: any, ClientID: any) {
    this.LoaderStatus = true;
    if (FormType === "" || AgentID === "" || (YearAssessment === "" && (FormType !== "CKM" && FormType !== "BNT CKM" && FormType !== "CP22"))) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let Params = {
        "FormType": FormType.trimEnd(),
        "YearAssessment": YearAssessment,
        "FirmID": Number(this.SessionFirmID),
        "TaxAgentID": Number(AgentID),
        "StaffID": Number(this.SessionStaffID),
        "ClientID": String(ClientID),
        "ModuleName": "Pembayar Cukai",
        "PageName": "Penerimaan Pelantikan Ejen Cukai"
      }
      const result = await this.apiServices.RegisterForm(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.ViewEBorang(ClientID);
        this.EBorangAccessView = true;
      }
    }
  }
  ResetFormValue(TaxRefNum: any, FormType: any, YearAssessment: any) {
    this.TaxRefNumResetForm = TaxRefNum;
    this.FormTypeResetForm = FormType;
    this.YearAssessmentResetForm = YearAssessment;
  }
  async ResetForm(TaxRefNum: any, FormType: any, YearAssessment: any) {
    this.LoaderStatus = true;
    let Params = {
      "ClientID": String(TaxRefNum),
      "FormType": FormType,
      "YearAssessment": YearAssessment,
      "FirmID": Number(this.SessionFirmID),
      "StaffID": Number(this.SessionStaffID),
      "ModuleName": "Pembayar Cukai",
      "PageName": "Penerimaan Pelantikan Ejen Cukai",
    }
    const result = await this.apiServices.ResetForm(Params);
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.ViewEBorang(TaxRefNum);
      this.EBorangAccessView = true;
      this.ResetValue();
      this.AlertType = "success";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    }
  }
  Distribute(TaxReturnFormID:any,StaffID: any, TaxpayerName: any, FormType: any, AgentID: any, StaffName: any, TaxpayerRefNum: any, RegisterDate: any) {
    this.DistributeOldStaffID = StaffID;
    //this.SupervisorList = StaffID;
    this.DistributeTaxpayerNameView = TaxpayerName;
    this.DistributeFormTypeView = FormType;
    this.DistributeStaffNameView = StaffName;
    this.DistributeTaxpayerRefNumView = TaxpayerRefNum;
    this.DistributeRegisterDateView = RegisterDate;
    this.DistributeTaxAgentIDView = AgentID;
    this.DistributeTaxReturnFormID = TaxReturnFormID;
    this.GetStaff(TaxReturnFormID, this.SessionStaffID, this.SessionFirmID);
  }
  async DistributeSubmit(TaxReturnFormID: any, StaffID: any, TaxAgentID: any, TaxRefNum: any, FormType: any) {
    this.LoaderStatus = true;
    if (StaffID === "" ) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila isi butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let Params = {
        "StaffID": StaffID,
        "ActionStaffID": this.SessionStaffID,
        "FirmID": this.SessionFirmID,
        "TaxReturnFormID": TaxReturnFormID,
        "ModuleName": "Pembayar Cukai",
        "PageName": "Penerimaan Pelantikan Ejen Cukai",
      }
      const result = await this.apiServices.DistributeForm(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.ViewEBorang(TaxRefNum);
        this.EBorangAccessView = true;
        this.ResetValue();
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      }
    }
  }
  async GetAcknowledment(FormType: any, YearAssessment: any, TaxRefNum: any) {

    // if (FormType === 'BE 2025' || FormType === 'B 2025' || FormType === 'BT 2025' || FormType === 'M 2025' || FormType === 'MT 2025') {
    //   this.noticeDialog.blockButton();
    //   return;
    // }
    
    this.LoaderStatus = true;
    let AmendmentCP204A = "";
    if (FormType.includes("CP204A")) {
      AmendmentCP204A = FormType.substring(FormType.lastIndexOf("-") + 1);
      FormType = FormType.substring(0, FormType.indexOf("-"));
    } else if (FormType.includes("CP204")) {
      FormType = FormType.slice(0, 5);
    } else if (FormType.includes("CP204B")) {
      FormType = FormType.slice(0, 6);
    } else if (FormType.includes("C1")) {
      FormType = FormType.slice(0, 2);
    } else if (FormType.includes("LE1")) {
      FormType = FormType.slice(0, 3);
    } else if (FormType.includes("CP22")) {
      FormType = FormType;
    } else {
      FormType = FormType.replace(/[0-9]/g, '').trim();
    }

    const result = await this.apiServices.GetAcknowledment(this.SessionFirmID, FormType, YearAssessment, TaxRefNum, AmendmentCP204A, this.SessionStaffIDNo);
    
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.LoaderStatus = false;
      this.GoAcknowledgment(result.url, result.paramBody);
    }
  }
  GoAcknowledgment(ParamUrl: any, ParamBody: any) {
    
    const existingForm = document.getElementById("semakan-post-form");
    if (existingForm) {
      existingForm.remove();
    }
    
    const form = document.createElement("form");
    form.id = "semakan-post-form";
    form.target = "Map";
    form.method = "POST";
    form.action = ParamUrl;

    for (let x = 0; x < ParamBody.length; x++) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = ParamBody[x].paramName;
      input.value = ParamBody[x].paramValue;
      form.appendChild(input);
    }

    document.body.appendChild(form);

    const map = window.open("", "Map");

    if (map) {
      this.LoaderStatus = false;
      form.submit();
    } else {
      alert("You must allow popups for this map to work.");
    }
  }
  async LoginForm(TaxReturnFormID: any, FormTypeYear: any) {

    // if (FormTypeYear === 'BE 2025' || FormTypeYear === 'B 2025' || FormTypeYear === 'BT 2025' || FormTypeYear === 'M 2025' || FormTypeYear === 'MT 2025') {
    //   this.noticeDialog.blockButton();
    //   return;
    // }

    let shouldOpenWindow = true;
    this.LoaderStatus = true;
    let URL = "", EncUserName = "", EncUserIDNo = "", EncPassword = "", EncTAIDNo = "", EncTaxPayerItRefNo = "", EncYear = "", YearAssessment = "";
    let Params = {
      "FirmID": Number(this.SessionFirmID),
      "StaffID": Number(this.SessionStaffID),
      "TaxReturnFormID": Number(TaxReturnFormID)
    };
    const result = await this.apiServices.FormLogin(Params);
    if (result.hasError) {
      this.ViewEBorang(this.TaxpayerTINView);
      this.EBorangAccessView = true;
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      if (FormTypeYear.includes("CP204") || FormTypeYear.includes("CP204B")) {
        if (FormTypeYear.substring(0, FormTypeYear.indexOf("-")) == "CP204A")
          YearAssessment = FormTypeYear.substring(FormTypeYear.indexOf("-") + 1, FormTypeYear.lastIndexOf("-"));
        else
          YearAssessment = FormTypeYear.substring(FormTypeYear.lastIndexOf("-") + 1);
      } else {
        YearAssessment = FormTypeYear.substring(FormTypeYear.lastIndexOf(" ") + 1);
      }

      EncUserName = await this.EncryptDecryptText('201', this.SessionStaffIDNo);
      EncUserIDNo = await this.EncryptDecryptText('201', this.SessionStaffIDNo);
      EncPassword = await this.EncryptDecryptText('201', result.password);
      EncTAIDNo = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncTAIDNo = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncTAIDNo = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncYear = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncTaxPayerItRefNo = await this.EncryptDecryptText('201', this.TaxpayerTINView);
      let tempRoles = "";
      const Roles = JSON.parse(this.SessionRoles);
      Roles.forEach((currentValue: any, index: any) => {
        if (currentValue === "0202")
          tempRoles = "PENYELIA";
        else if (currentValue === "0203")
          tempRoles = "STAF";
        else if (currentValue === "0204")
          tempRoles = "EJEN CUKAI";
      });
      switch (result.formType) {
        case "P":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=P" + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=P&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=P";
          break;
        case "E":
          if (Number(YearAssessment) >= 2022)
            this.CreateCP8DForm(TaxReturnFormID, YearAssessment)

          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=E" + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=E&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=E";
          break;
        case "CP8D":
          const cp8dUrl: string = result.url;
          const urlObj = new window.URL(cp8dUrl);
          const token = sessionStorage.getItem('token');

          if (token) {
            urlObj.searchParams.set('signature', token);
          }

          URL = urlObj.toString();
          break;
        case "C":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "C1":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2020)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "BNTC1":
          if (Number(YearAssessment) > 2020)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "BNT C":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&NoRujukan=" + EncTaxPayerItRefNo + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&NoRujukan=" + EncTaxPayerItRefNo + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&NoRujukan=" + EncTaxPayerItRefNo;
          break;
        case "TF":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType)  + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2019)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "TP":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&IDType=1&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2019)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&IDType=1&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&IDType=1";
          break;
        case "TC":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTTC":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "PT":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTPT":
          if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "TA":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTTA":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "TR":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTTR":
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "TJ":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&TahunTaksiran=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "LE1":
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          break;
        case "CP204":
        case "CP204B":
          URL = result.url + "?IPAddress=" + this.SessionIPAddress + "&TaxReturnFormID=" + TaxReturnFormID +
            "&UserName=" + EncUserName + "&Password=" + EncPassword + "&FirmID=" + this.SessionFirmID +
            "&Nama=" + encodeURI(result.taxAgentName) + "&ID=" + EncTAIDNo + "&CompanyRefNo=" + EncTaxPayerItRefNo + "&Jenis_File=" + result.taxPayerFileType +
            "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&Roc_No=" + encodeURI(result.taxPayerROC) + "&Jawatan=" + tempRoles + "&CompanyName=" + encodeURI(result.taxPayerName) +
            "&LicenseNo=" + result.taxAgentLicenseNo + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          break;
        case "CP204A":
          URL = result.url + "?IPAddress=" + this.SessionIPAddress + "&TaxReturnFormID=" + TaxReturnFormID +
            "&UserName=" + EncUserName + "&Password=" + EncPassword + "&FirmID=" + this.SessionFirmID +
            "&Nama=" + encodeURI(result.taxAgentName) + "&ID=" + EncTAIDNo + "&CompanyRefNo=" + EncTaxPayerItRefNo + "&Jenis_File=" + result.taxPayerFileType +
            "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&Roc_No=" + encodeURI(result.taxPayerROC) + "&Jawatan=" + tempRoles + "&CompanyName=" + encodeURI(result.taxPayerName) +
            "&LicenseNo=" + result.taxAgentLicenseNo + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&Pindaan=" + result.pindaan;
          break;
        case "CPP":
        case "CPE":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2019)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNT CPP":
          let tempFormType = result.formType.replace(" ", "")
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', tempFormType) + "&language=en-US";
          break;
        case "CKM":
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&language=en-US";
          break;
        case "BE":
        case "B":
        case "BT":
        case "M":
        case "MT":
          if (Number(YearAssessment) >= this.yearBeStartOauth) {
            this.windowForm.openPostForm(result.url, {
              auth_type: "digicert",
              form_tin: this.TaxpayerTINView,
              form_type: result.formType,
              form_year: YearAssessment,
              cert_type: 2,
              TaxReturnFormID: TaxReturnFormID,
              language: "en-US",
            });
            shouldOpenWindow = false;
          } else {
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&ID=" + EncUserIDNo + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&TaxReferenceNo=" + result.firmTaxRefNum;
          }
          break;
        case "PE":
        case "PB":
          this.windowForm.openPostForm(result.url, {
            auth_type: "digicert",
            form_tin: this.TaxpayerTINView,
            form_type: result.formType,
            form_year: YearAssessment,
            cert_type: 2,
            TaxReturnFormID: TaxReturnFormID,
            language: "en-US",
          });
          shouldOpenWindow = false;
          break;

        default: // IND
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&ID=" + EncUserIDNo + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&TaxReferenceNo=" + result.firmTaxRefNum;
          break;
      }
      if (shouldOpenWindow && URL) {
        this.windowForm.openWindow(URL); // <-- use service
      }
      this.LoaderStatus = false;
    }
  }
  async StatusMyTax(TaxRefNum:any) {
    this.LoaderStatus = true;
    let EncTaxRefNum = await this.EncryptDecryptText('201', TaxRefNum);
    let URL = `${this.MyTaxAddress}/taef?data=${EncTaxRefNum}&type=SMT`;
    window.open(URL, "_blank");
    this.LoaderStatus = false;
  }
  async UpdateProfile(TaxRefNum:any) {
    this.LoaderStatus = true;
    let EncTaxRefNum = await this.EncryptDecryptText('201', TaxRefNum);
    let URL = `${this.MyTaxAddress}/taef?data=${EncTaxRefNum}&type=KKP`;
    window.open(URL, "_blank");
    this.LoaderStatus = false;
  }
  async EncryptDecryptText(Type: any, Text: any) {
    let EncryptedText;
    const result = await this.apiServices.GetEncryptDecrypt(Type, Text);
    EncryptedText = JSON.parse(JSON.stringify(result));
    return EncryptedText;
  }
  async CreateCP8DForm(TaxReturnFormID: any, FormYear: any) {
    //call api create cp8d

    let Params = {
      "taxReturnFormID": TaxReturnFormID,
      "formYear": FormYear
    }
    const result = await this.apiServices.CreateCP8D(Params);
  }
  ResetValue() {
    this.FormTypeInput = "";
    this.FormTypeList = [];
    this.YearAssessmentList = [];
    this.YearAssessmentRegisterStatus = false;
  }
}
